var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUtbetalinger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/32-content/box-2 Copy@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 33.6,
    height: 33.6
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning",
    transform: "translate(-309.000000, -4868.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/24-business-finance/coin-receive",
    transform: "translate(309.000000, 4868.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29999993,18.2 L0.69999993,18.2 C0.31359993,18.2 -7.00000555e-08,18.5320471 -7.00000555e-08,18.9411765 L-7.00000555e-08,30.0588235 C-7.00000555e-08,30.4679529 0.31359993,30.8 0.69999993,30.8 L6.29999993,30.8 C6.68499993,30.8 6.99999993,30.4679529 6.99999993,30.0588235 L6.99999993,18.9411765 C6.99999993,18.5320471 6.68499993,18.2 6.29999993,18.2 Z",
    id: "Fill/coin-receive",
    fill: "#669DB4",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.200000, 0.000000)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,9.8 C7.602,9.8 9.8,7.602 9.8,4.9 C9.8,2.1966 7.602,0 4.9,0 C2.198,0 0,2.1966 0,4.9 C0,7.602 2.198,9.8 4.9,9.8 Z",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,3.5 C4.2,3.1136 4.5136,2.8 4.9,2.8 C5.285,2.8 5.6,3.1136 5.6,3.5 L5.6,6.3 C5.6,6.6864 5.285,7 4.9,7 C4.5136,7 4.2,6.6864 4.2,6.3 L4.2,3.5 Z",
    fill: "#B26D14"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    strokeWidth: 1,
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.800000, 8.400000)",
    fillRule: "nonzero",
    id: "Path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.9,9.8 C7.602,9.8 9.8,7.602 9.8,4.9 C9.8,2.1966 7.602,0 4.9,0 C2.198,0 0,2.1966 0,4.9 C0,7.602 2.198,9.8 4.9,9.8 Z",
    fill: "#FFBD66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,3.5 C4.2,3.1136 4.5136,2.8 4.9,2.8 C5.285,2.8 5.6,3.1136 5.6,3.5 L5.6,6.3 C5.6,6.6864 5.285,7 4.9,7 C4.5136,7 4.2,6.6864 4.2,6.3 L4.2,3.5 Z",
    fill: "#B26D14"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M14.8970199,25.5532562 C14.7916862,25.7202866 14.8417012,25.9410813 15.0087316,26.046415 C15.0243355,26.0562553 15.0406775,26.0648731 15.0576114,26.0721914 L19.6,28.0352838 L28,25.0160726 C29.9050585,24.4738536 31.7010598,23.7256058 33.3890134,25.4037664 C33.5514826,25.5668613 33.6262471,25.7986277 33.5917404,26.0261022 C33.5543581,26.2550073 33.4105801,26.4495766 33.2035398,26.5525839 C29.2309538,28.5283212 26.5609964,30.0462482 24.6113668,31.1550073 C21.6653556,32.8303066 20.2548935,33.6 18.6057599,33.6 C17.2226155,33.6 15.671251,33.057781 12.8992112,32.0548905 C11.4901868,31.544146 9.73609527,30.910365 7.49172075,30.1649927 C7.19841363,30.067708 7,29.7944526 7,29.4868613 L7,20.3098592 C7,19.9180169 7.35689563,19.6 7.79664202,19.6 L10.1865681,19.6 C12.3528749,19.6 14.0162489,20.2969485 15.1637185,21 L21.7,21 C22.859798,21 23.8,21.940202 23.8,23.1 C23.8,24.259798 22.859798,25.2 21.7,25.2 L15.5374257,25.2 C15.2774671,25.2 15.0356862,25.3333694 14.8970199,25.5532562 Z",
    id: "Path",
    fill: "#FFE5C2",
    fillRule: "evenodd",
    mask: "url(#mask-2)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtbetalinger);
export default __webpack_public_path__ + "static/media/Utbetalinger.3caa7ec409f1cdef3f5ff538bb3c2941.svg";
export { ForwardRef as ReactComponent };